import React from 'react';
import { FiAlertTriangle, FiAlertCircle, FiInfo, FiMail } from 'react-icons/fi';
import { Button } from 'components';
import * as Ui from './ActionBanner.styles';

const variantIcon = {
  error: FiAlertCircle,
  warning: FiAlertTriangle,
  info: FiInfo,
  mail: FiMail,
};

const ActionBanner = ({
  title,
  description,
  onButtonClick,
  buttonLabel,
  buttonVariant = 'primary',
  variant = 'warning',
}) => {
  const Icon = variantIcon[variant];

  return (
    <Ui.LimitWarning $variant={variant}>
      <Ui.LimitWarningIcon $variant={variant}>
        <Icon size={20} />
      </Ui.LimitWarningIcon>
      <Ui.LimitWarningContent>
        {title && <Ui.LimitWarningTitle>{title}</Ui.LimitWarningTitle>}
        {description !== undefined && (
          <Ui.LimitWarningDescription>{description}</Ui.LimitWarningDescription>
        )}
      </Ui.LimitWarningContent>
      {onButtonClick && (
        <Ui.LimitWarningButton>
          <Button variant={buttonVariant} onClick={onButtonClick} size="xl">
            {buttonLabel || 'Action'}
          </Button>
        </Ui.LimitWarningButton>
      )}
    </Ui.LimitWarning>
  );
};

export default ActionBanner;
